import { addDoc, collection, deleteDoc, doc, onSnapshot, orderBy, query, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../config';
import type { PrayerRequest } from './types';

export function subscribeToPrayerRequests(creatorId: string, cb: (items: PrayerRequest[]) => void) {
    const ref = collection(db, 'missionpages', creatorId, 'prayerrequests');
    const q = query(ref, orderBy('createdAt', 'asc'));
    return onSnapshot(q, (snap) => {
        const items: PrayerRequest[] = [] as any;
        snap.forEach((d) => items.push({ id: d.id, ...(d.data() as any) }));
        cb(items);
    });
}

export async function addPrayerRequest(creatorId: string, text: string): Promise<string> {
    const ref = collection(db, 'missionpages', creatorId, 'prayerrequests');
    const docRef = await addDoc(ref, { text, createdAt: serverTimestamp() } as any);
    return docRef.id;
}

export async function updatePrayerRequest(creatorId: string, id: string, text: string): Promise<void> {
    const ref = doc(db, 'missionpages', creatorId, 'prayerrequests', id);
    await updateDoc(ref, { text, updatedAt: serverTimestamp() });
}

export async function deletePrayerRequest(creatorId: string, id: string): Promise<void> {
    const ref = doc(db, 'missionpages', creatorId, 'prayerrequests', id);
    await deleteDoc(ref);
}


